import { useShell } from '../shell/use-shell.js';
import { CommunityFeedbackSummary } from './community-feedback-summary.js';
import { FeedbackInbox } from './feedback-inbox.js';

// ---------------------------------------------------------------------------
// Feedback screen shell.
//
// Stacks the Community Feedback summary above the Feedback stream (the
// existing inbox: channel filter + activity panel + message/poll/form feeds),
// wrapped in a labelled surface.
// ---------------------------------------------------------------------------

export function FeedbackScreen(): JSX.Element {
  const { activeStudio, activeGame } = useShell();

  return (
    <div className="flex flex-col gap-4 lg:gap-6">
      {activeGame !== null && (
        <CommunityFeedbackSummary
          gameId={activeGame.id}
          studioShortId={activeStudio.shortId}
          gameShortId={activeGame.shortId}
        />
      )}
      <section className="flex flex-col gap-4 rounded-lg border border-border bg-surface-2 p-4 sm:gap-5 sm:p-5">
        <h2 className="font-display text-base font-bold text-text">Feedback stream</h2>
        <FeedbackInbox />
      </section>
    </div>
  );
}
